<template>
  <div class="container mt-4">
    <div class="card p-4 shadow-sm">
      <h4 class="mb-3">Change Password</h4>

      <form @submit.prevent="changePassword">

        <!-- Old Password -->
        <div class="mb-3">
          <label class="form-label">Old Password</label>
          <input
            type="password"
            class="form-control"
            v-model="form.old_password"
            @input="clearError('old_password')"
          />
          <div v-if="errors.old_password" class="text-danger mt-1">
            {{ errors.old_password }}
          </div>
        </div>

        <!-- New Password -->
        <div class="mb-3">
          <label class="form-label">New Password</label>
          <input
            type="password"
            class="form-control"
            v-model="form.new_password"
            @input="clearError('new_password')"
          />
          <div v-if="errors.new_password" class="text-danger mt-1">
            {{ errors.new_password }}
          </div>
        </div>

        <!-- Confirm Password -->
        <div class="mb-3">
          <label class="form-label">Confirm Password</label>
          <input
            type="password"
            class="form-control"
            v-model="form.confirm_password"
            @input="clearError('confirm_password')"
          />
          <div v-if="errors.confirm_password" class="text-danger mt-1">
            {{ errors.confirm_password }}
          </div>
        </div>

        <!-- Success Message -->
        <div v-if="successMessage" class="alert alert-success">
          {{ successMessage }}
        </div>

        <!-- Submit -->
        <div class="d-flex justify-content-end mt-3">
          <button class="btn btn-primary" :disabled="loading">
            {{ loading ? "Updating..." : "Update Password" }}
          </button>
        </div>

      </form>
    </div>
  </div>
</template>

<script>
import apiUrls from "@/urls";

export default {
  name: "ChangePassword",

  data() {
    return {
      loading: false,
      errorMessage: "",
      successMessage: "",
      errors: {},

      form: {
        old_password: "",
        new_password: "",
        confirm_password: ""
      }
    }
  },

  methods: {
    clearError(field) {
      if (this.errors[field]) {
        this.errors[field] = ""
      }

      this.errorMessage = ""
    },

    async changePassword() {
      this.errorMessage = ""
      this.successMessage = ""
      this.errors = {};
      this.loading = true

      if (!this.form.old_password.trim()) this.errors.old_password = this.$t('error.required');
      if (!this.form.new_password.trim()) this.errors.new_password = this.$t('error.required');
      if (!this.form.confirm_password.trim()) this.errors.confirm_password = this.$t('error.required');

      // Password match validation
      if (
        this.form.new_password &&
        this.form.confirm_password &&
        this.form.new_password !== this.form.confirm_password
      ) {
        this.errors.confirm_password = this.$t("password_not_match");
      }

      if (Object.keys(this.errors).length > 0) {
        this.loading = false;
        return;
      }

      try {
        const response = await this.$axios.post(
          apiUrls.change_password.post,
          this.form,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access")}`
            }
          }
        )

        this.successMessage = response.data.message

        // logout user after password change
        setTimeout(() => {
          localStorage.removeItem("access")
          localStorage.removeItem("refresh")

          this.$router.push("/login")
        }, 2000)

      } catch (error) {
          if (error.response && error.response.data) {

          const data = error.response.data

          // reset errors
          this.errors = {}

          if (data.old_password) {
            this.errors.old_password = data.old_password[0]
          }

          if (data.new_password) {
            this.errors.new_password = data.new_password[0]
          }

          if (data.confirm_password) {
            this.errors.confirm_password = data.confirm_password[0]
          }

          if (data.detail) {
            this.errorMessage = data.detail
          }

        } else {
          this.errorMessage = "Server not reachable"
        }

      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.card {
  max-width: 500px;
  margin: auto;
}
</style>
